import React from "react";
import { useFFcardBank } from "../../components/FcardBank/hooks/useFcardBank";
/* This example requires Tailwind CSS v2.0+ */
import { ChevronRightIcon } from "@heroicons/react/solid";
import { useLocation, useNavigate } from "react-router-dom";
import Swal from "sweetalert2";
import { useBank } from "../../hooks/useBank";
import FContainer from "../../components/FContainer/FContainer";
import Fbutton from "../../components/Finputs/FButton/Fbutton";

const BankDetailScreen = ({ props }) => {
  const parameters = useLocation();
  const { deleteBank, banks, setBanks } = useBank();
  const route = useNavigate();

  const { id, accountNumber, accountHolderName, accountType } =
    parameters.state;

  const onDeleteClickBanks = () => {
    Swal.fire({
      showCloseButton: true,
      title: "Eliminar cuenta",
      text: "¿Estás seguro de eliminar la cuenta bancaria?",
      imageUrl: require("../../components/assets/images/pregunta.png"),
      imageWidth: 150,
      imageHeight: 150,
      imageAlt: "Custom image",
      confirmButtonColor: "#28a745",
      cancelButtonColor: "#dc3545",
      showCancelButton: true,
      confirmButtonText: "Aceptar",
      cancelButtonText: "Cancelar",
      reverseButtons: true,
    }).then((result) => {
      if (result.isConfirmed) {
        confirmDelete();
      }
    });
  };

  const confirmDelete = async () => {
    let resp = await deleteBank(id);
    if (resp == true) {
      route("/BankScreen");
    } else {
      Swal.fire({
        showCloseButton: true,
        title: "Error",
        text: "No se pudo eliminar la cuenta bancaria",
        imageUrl: require("../../components/assets/images/boton-x.png"),
        imageWidth: 150,
        imageHeight: 150,
        imageAlt: "Custom image",
        confirmButtonColor: "#28a745",
        cancelButtonColor: "#dc3545",
        confirmButtonText: "Aceptar",
        cancelButtonText: "Cancelar",
        reverseButtons: true,
      });
    }
  };

  return (
    <>
      <FContainer>
        <div className="border-0 w-full grid gap-2 grid-cols-1 text-[4.5vw] smm:text-[20px] xxs:text-[18px]">
          <div className="border-0 col-span-1 grid place-items-center">
            <img
              src={require("../../components/assets/images/credit-card.png")}
              className="w-[50vw] smm:w-[150px]"
              alt=""
            />
          </div>
          <div className="border-0 col-span-1 font-bold  grid place-items-center">
            Propietario:
          </div>
          <div className="border-0 col-span-1 font-regular  grid place-items-center">
            {accountHolderName}
          </div>
          <div className="border-0 col-span-1 font-bold grid place-items-center">
            Número de cuenta:
          </div>
          <div className="border-0 col-span-1 font-regular  grid place-items-center">
            {accountNumber}
          </div>
          <div className="border-0 col-span-1 font-bold  grid place-items-center">
            Tipo de cuenta:
          </div>
          <div className="border-0 col-span-1 font-regular  grid place-items-center">
            {accountType.code}
          </div>
          <div className="border-0 col-span-1">
            <Fbutton
              type="error"
              value="Eliminar cuenta"
              onClick={onDeleteClickBanks}
            />
          </div>
        </div>
      </FContainer>
    </>
  );
};

export default BankDetailScreen;
